import { useEffect, type FC } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getApiLangFromI18n } from "src/utils/apiLang";
import { draftToCampaignData, type DraftLocationState } from "../../../shared/CampaignDraftUtils";
import { isSitemapAvailable } from "../../../CampaignSetup/CampaignSetupUtils";
import AiCampaignWizard from "./AiCampaignWizard";
import { CREATE_CAMPAIGN_ROUTE } from "./AiCampaignConstants";

const AIEmailEditor: FC = () => {
  const locationState = useLocation().state as DraftLocationState | null;
  const draft = locationState?.draft ?? null;
  const campaignData = locationState?.campaignData ?? (draft ? draftToCampaignData(draft) : undefined);
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const hasCampaignData = Boolean(campaignData);

  useEffect(() => {
    if (!hasCampaignData) {
      return;
    }
    let isActive = true;
    void isSitemapAvailable(getApiLangFromI18n(i18n)).then(isAvailable => {
      if (!isAvailable && isActive) {
        navigate(CREATE_CAMPAIGN_ROUTE, { replace: true, state: { channel: "email", use_ai: false } });
      }
    });
    return () => {
      isActive = false;
    };
  }, [hasCampaignData, i18n, navigate]);

  if (!campaignData) {
    return <Navigate to={CREATE_CAMPAIGN_ROUTE} replace />;
  }

  return <AiCampaignWizard campaignData={campaignData} initialDraft={draft} />;
};

export default AIEmailEditor;
